var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "v-layout",
        [
          _c(
            "v-flex",
            [
              _c(
                "v-btn",
                {
                  attrs: { color: "primary" },
                  on: { click: _vm.showAddItemDialog }
                },
                [
                  _c("v-icon", { attrs: { dark: "" } }, [_vm._v("add")]),
                  _vm._v(" " + _vm._s(_vm.addItemBtnText) + "\n      ")
                ],
                1
              ),
              _vm._v(" "),
              _vm.isEditMode
                ? _c(
                    "v-btn",
                    {
                      attrs: { color: "secondary", disabled: _vm.loading },
                      on: {
                        click: function($event) {
                          $event.stopPropagation()
                          return _vm.cancelEditData()
                        }
                      }
                    },
                    [
                      _vm._v(
                        "\n        " + _vm._s(_vm.$t("cancel")) + "\n      "
                      )
                    ]
                  )
                : _vm._e()
            ],
            1
          ),
          _vm._v(" "),
          _c("v-spacer"),
          _vm._v(" "),
          _c(
            "v-flex",
            { attrs: { xs6: "", sm4: "", md2: "" } },
            [
              _c("v-autocomplete", {
                attrs: {
                  items: _vm.warehousesSites,
                  "item-text": "siteName",
                  "item-key": "key",
                  "return-object": "",
                  label: _vm.$t("warehouseSite"),
                  disabled: _vm.isEditMode,
                  hint: _vm.$t("selectASiteBeforeEditLocation"),
                  "persistent-hint": ""
                },
                model: {
                  value: _vm.currentWarehouseSite,
                  callback: function($$v) {
                    _vm.currentWarehouseSite = $$v
                  },
                  expression: "currentWarehouseSite"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c("v-spacer"),
          _vm._v(" "),
          !_vm.isEditMode
            ? _c(
                "v-flex",
                [
                  _c(
                    "v-layout",
                    [
                      _c("v-text-field", {
                        attrs: {
                          "prepend-icon": "view_week",
                          label: _vm.$t("barcode"),
                          "single-line": "",
                          "hide-details": "",
                          clearable: ""
                        },
                        model: {
                          value: _vm.barcode,
                          callback: function($$v) {
                            _vm.barcode = $$v
                          },
                          expression: "barcode"
                        }
                      }),
                      _vm._v(" "),
                      _c(
                        "v-btn",
                        {
                          attrs: { color: "primary" },
                          on: { click: _vm.printBarcode }
                        },
                        [
                          _c("v-icon", { attrs: { dark: "" } }, [
                            _vm._v("print")
                          ])
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c("v-spacer"),
          _vm._v(" "),
          _c(
            "v-flex",
            { attrs: { xs5: "", md3: "" } },
            [
              _c("v-text-field", {
                attrs: {
                  "append-icon": "search",
                  label: _vm.$t("search"),
                  "single-line": "",
                  "hide-details": "",
                  clearable: ""
                },
                on: {
                  keyup: function($event) {
                    if (
                      !$event.type.indexOf("key") &&
                      _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                    ) {
                      return null
                    }
                    return _vm.filterEnter.apply(null, arguments)
                  }
                },
                model: {
                  value: _vm.search,
                  callback: function($$v) {
                    _vm.search = $$v
                  },
                  expression: "search"
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-layout",
        { attrs: { "align-baseline": "", "justify-start": "" } },
        [
          _c("v-flex", { staticClass: "success--text caption" }, [
            _c("span", { staticClass: "realtime-border px-1" }, [
              _vm._v(_vm._s(_vm.$t("realTIME")))
            ])
          ])
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-data-table",
        {
          staticClass: "elevation-1",
          attrs: {
            headers: _vm.headers,
            items: _vm.items,
            search: _vm.search,
            loading: _vm.loading,
            pagination: _vm.pagination,
            "rows-per-page-items": _vm.rowPerPage
          },
          on: {
            "update:pagination": function($event) {
              _vm.pagination = $event
            }
          },
          scopedSlots: _vm._u([
            {
              key: "progress",
              fn: function() {
                return [
                  _c("v-progress-linear", {
                    attrs: { color: "blue", indeterminate: "" }
                  })
                ]
              },
              proxy: true
            },
            {
              key: "items",
              fn: function(props) {
                return [
                  _vm.mode === "upc"
                    ? _c("td", { staticClass: "text-xs-left" }, [
                        _vm._v(_vm._s(props.item.upc))
                      ])
                    : _c("td", { staticClass: "text-xs-left" }, [
                        _vm._v(_vm._s(props.item.sku))
                      ]),
                  _vm._v(" "),
                  _vm.mode === "sku"
                    ? _c("td", { staticClass: "text-xs-left" }, [
                        _vm._v(
                          _vm._s(
                            _vm.organizationKeyToId.get(
                              props.item.organizationKey
                            )
                          )
                        )
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "td",
                    { staticClass: "text-xs-left" },
                    [
                      _vm.isEditMode
                        ? [
                            _c("v-text-field", {
                              model: {
                                value: props.item.description,
                                callback: function($$v) {
                                  _vm.$set(props.item, "description", $$v)
                                },
                                expression: "props.item.description"
                              }
                            })
                          ]
                        : [
                            _vm._v(
                              "\n          " +
                                _vm._s(props.item.description) +
                                "\n        "
                            )
                          ]
                    ],
                    2
                  ),
                  _vm._v(" "),
                  _c(
                    "td",
                    { staticClass: "text-xs-left" },
                    [
                      _vm.isEditMode
                        ? [
                            _c("v-combobox", {
                              attrs: {
                                chips: "",
                                multiple: "",
                                "deletable-chips": "",
                                clearable: "",
                                disabled: !_vm.currentWarehouseSite.key
                              },
                              model: {
                                value: props.item.location,
                                callback: function($$v) {
                                  _vm.$set(props.item, "location", $$v)
                                },
                                expression: "props.item.location"
                              }
                            })
                          ]
                        : [
                            _vm._v(
                              "\n          " +
                                _vm._s(
                                  props.item.location &&
                                    props.item.location.join(", ")
                                ) +
                                "\n        "
                            )
                          ]
                    ],
                    2
                  ),
                  _vm._v(" "),
                  _c(
                    "td",
                    { staticClass: "text-xs-left" },
                    [
                      _vm.isEditMode
                        ? [
                            _c("v-select", {
                              attrs: {
                                items: _vm.sizes,
                                "item-text": "name",
                                "item-value": "sortKey",
                                disabled: _vm.loading
                              },
                              model: {
                                value: props.item.size,
                                callback: function($$v) {
                                  _vm.$set(props.item, "size", $$v)
                                },
                                expression: "props.item.size"
                              }
                            }),
                            _vm._v(" "),
                            props.item.size === "custom"
                              ? _c("v-text-field", {
                                  attrs: { prefix: "$", solo: "" },
                                  model: {
                                    value: props.item.unitFee,
                                    callback: function($$v) {
                                      _vm.$set(
                                        props.item,
                                        "unitFee",
                                        _vm._n($$v)
                                      )
                                    },
                                    expression: "props.item.unitFee"
                                  }
                                })
                              : _vm._e()
                          ]
                        : [_vm._v(_vm._s(_vm.getFeeString(props.item)))]
                    ],
                    2
                  ),
                  _vm._v(" "),
                  _c("td", { staticClass: "text-xs-left" }, [
                    _vm._v(
                      "\n        " + _vm._s(props.item.snTemplate) + "\n      "
                    )
                  ]),
                  _vm._v(" "),
                  _c(
                    "td",
                    { staticClass: "text-xs-left" },
                    [
                      _c(
                        "v-flex",
                        _vm._l(
                          _vm.getPricingPlanFromUpc(props.item.upc),
                          function(item) {
                            return _c("v-chip", { key: item }, [
                              _vm._v(_vm._s(item))
                            ])
                          }
                        ),
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "td",
                    [
                      _c(
                        "v-layout",
                        { attrs: { "justify-center": "" } },
                        [
                          _c(
                            "v-tooltip",
                            {
                              attrs: { top: "" },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "activator",
                                    fn: function(ref) {
                                      var on = ref.on
                                      return [
                                        _c(
                                          "v-btn",
                                          _vm._g(
                                            {
                                              attrs: {
                                                icon: "",
                                                flat: "",
                                                color: "primary",
                                                disabled:
                                                  JSON.stringify(
                                                    props.item.approvedSkus
                                                  ) === "{}"
                                              },
                                              on: {
                                                click: function($event) {
                                                  return _vm.showSkuDetailDialog(
                                                    props.item
                                                  )
                                                }
                                              }
                                            },
                                            on
                                          ),
                                          [_c("v-icon", [_vm._v("info")])],
                                          1
                                        )
                                      ]
                                    }
                                  }
                                ],
                                null,
                                true
                              )
                            },
                            [
                              _vm._v(" "),
                              _c("span", [
                                _vm._v(
                                  " " + _vm._s(_vm.$t("approvedSKUs")) + " "
                                )
                              ])
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "v-tooltip",
                            {
                              attrs: { top: "" },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "activator",
                                    fn: function(ref) {
                                      var on = ref.on
                                      return [
                                        _c(
                                          "v-btn",
                                          _vm._g(
                                            {
                                              attrs: {
                                                icon: "",
                                                flat: "",
                                                color: "primary",
                                                disabled:
                                                  !_vm.currentWarehouseSite
                                                    .key || _vm.isEditMode
                                              },
                                              on: {
                                                click: function($event) {
                                                  return _vm.showUPCDescEditor(
                                                    props.item
                                                  )
                                                }
                                              }
                                            },
                                            on
                                          ),
                                          [_c("v-icon", [_vm._v("edit")])],
                                          1
                                        )
                                      ]
                                    }
                                  }
                                ],
                                null,
                                true
                              )
                            },
                            [
                              _vm._v(" "),
                              _c("span", [
                                _vm._v(" " + _vm._s(_vm.$t("editUPC")) + " ")
                              ])
                            ]
                          ),
                          _vm._v(" "),
                          !_vm.isEditMode
                            ? _c(
                                "v-btn",
                                {
                                  attrs: {
                                    dark: "",
                                    color: "red",
                                    icon: "",
                                    flat: ""
                                  },
                                  on: {
                                    click: function($event) {
                                      $event.stopPropagation()
                                      return _vm.deleteItem(props.item)
                                    }
                                  }
                                },
                                [
                                  _c("v-icon", { attrs: { dark: "" } }, [
                                    _vm._v("cancel")
                                  ])
                                ],
                                1
                              )
                            : _vm._e()
                        ],
                        1
                      )
                    ],
                    1
                  )
                ]
              }
            }
          ])
        },
        [
          _vm._v(" "),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "text-xs-center",
              attrs: { slot: "no-results" },
              slot: "no-results"
            },
            [
              _c("v-icon", [_vm._v("warning")]),
              _vm._v(
                "\n      " +
                  _vm._s(_vm.$t("upcSearchNoResult", { search: _vm.search })) +
                  "\n    "
              )
            ],
            1
          )
        ]
      ),
      _vm._v(" "),
      _c("SimpleTextPopup", {
        attrs: { title: _vm.$t("approvedSKUs"), hideRgtBtn: true, medium: "" },
        on: {
          popupClose: function($event) {
            _vm.showApprovedSkus = false
          }
        },
        scopedSlots: _vm._u([
          {
            key: "input",
            fn: function() {
              return [
                _c(
                  "v-container",
                  { attrs: { fluid: "" } },
                  [
                    _c("v-data-table", {
                      staticClass: "levation-2 myDense",
                      attrs: {
                        headers: [
                          {
                            text: _vm.$t("index"),
                            sortable: false,
                            value: "upc"
                          },
                          {
                            text: _vm.$t("organization"),
                            sortable: false,
                            value: "upc",
                            width: "15%"
                          },
                          {
                            text: _vm.$t("skus"),
                            sortable: false,
                            value: "keywordForSearch"
                          }
                        ],
                        items: _vm.selectedUpcDetails,
                        pagination: _vm.pagination,
                        "item-key": "upc",
                        loading: _vm.isDeletingSku,
                        "rows-per-page-items": _vm.rowPerPage
                      },
                      on: {
                        "update:pagination": function($event) {
                          _vm.pagination = $event
                        }
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "items",
                          fn: function(props) {
                            return [
                              _c("td", { staticClass: "subheading" }, [
                                _vm._v(_vm._s(props.index + 1))
                              ]),
                              _vm._v(" "),
                              _c("td", { staticClass: "text-xs-left" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.organizationKeyToId.get(
                                      props.item.organizationKey
                                    )
                                  )
                                )
                              ]),
                              _vm._v(" "),
                              _c(
                                "td",
                                { staticClass: "text-xs-left" },
                                [
                                  _c(
                                    "v-layout",
                                    _vm._l(props.item.approvedSkus, function(
                                      sku
                                    ) {
                                      return _c(
                                        "v-chip",
                                        {
                                          key: sku,
                                          attrs: { close: "" },
                                          on: {
                                            input: function($event) {
                                              return _vm.removeSku(
                                                sku,
                                                props.item
                                              )
                                            }
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "\n                  " +
                                              _vm._s(sku) +
                                              " \n                "
                                          )
                                        ]
                                      )
                                    }),
                                    1
                                  )
                                ],
                                1
                              )
                            ]
                          }
                        }
                      ])
                    })
                  ],
                  1
                )
              ]
            },
            proxy: true
          }
        ]),
        model: {
          value: _vm.showApprovedSkus,
          callback: function($$v) {
            _vm.showApprovedSkus = $$v
          },
          expression: "showApprovedSkus"
        }
      }),
      _vm._v(" "),
      _c("FormSubmitPopup", {
        attrs: {
          title: _vm.$t("editUPC"),
          rightMethod: _vm.updateUPC,
          medium: ""
        },
        on: {
          popupClose: function($event) {
            _vm.showEditUPCDesc = false
          }
        },
        scopedSlots: _vm._u([
          {
            key: "input",
            fn: function() {
              return [
                _c(
                  "v-layout",
                  [
                    _c("v-text-field", {
                      attrs: { name: "upcDesc", label: _vm.$t("description") },
                      model: {
                        value: _vm.editingUPCItem.description,
                        callback: function($$v) {
                          _vm.$set(_vm.editingUPCItem, "description", $$v)
                        },
                        expression: "editingUPCItem.description"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "v-layout",
                  [
                    _c("v-combobox", {
                      attrs: {
                        label: _vm.$t("location"),
                        chips: "",
                        multiple: "",
                        "deletable-chips": "",
                        clearable: "",
                        disabled: !_vm.currentWarehouseSite.key
                      },
                      model: {
                        value: _vm.editingUPCItem.location,
                        callback: function($$v) {
                          _vm.$set(_vm.editingUPCItem, "location", $$v)
                        },
                        expression: "editingUPCItem.location"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "v-layout",
                  [
                    _c("v-text-field", {
                      attrs: { label: _vm.$t("snTemplate") },
                      model: {
                        value: _vm.editingUPCItem.snTemplate,
                        callback: function($$v) {
                          _vm.$set(_vm.editingUPCItem, "snTemplate", $$v)
                        },
                        expression: "editingUPCItem.snTemplate"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "v-layout",
                  [
                    _c(
                      "v-flex",
                      { attrs: { sm4: "", "mr-2": "" } },
                      [
                        _c("v-select", {
                          attrs: {
                            items: _vm.sizes,
                            label: _vm.$t("size"),
                            "item-text": "name",
                            "item-value": "sortKey",
                            disabled: _vm.loading
                          },
                          model: {
                            value: _vm.editingUPCItem.size,
                            callback: function($$v) {
                              _vm.$set(_vm.editingUPCItem, "size", $$v)
                            },
                            expression: "editingUPCItem.size"
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "v-flex",
                      { attrs: { sm3: "", "mr-2": "" } },
                      [
                        _vm.editingUPCItem.size === "custom"
                          ? _c("v-text-field", {
                              attrs: {
                                label: _vm.$t("inboundFee"),
                                prefix: "$"
                              },
                              model: {
                                value: _vm.editingUPCItem.inboundFee,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.editingUPCItem,
                                    "inboundFee",
                                    _vm._n($$v)
                                  )
                                },
                                expression: "editingUPCItem.inboundFee"
                              }
                            })
                          : _vm._e()
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "v-flex",
                      { attrs: { sm3: "", "mr-2": "" } },
                      [
                        _vm.editingUPCItem.size === "custom"
                          ? _c("v-text-field", {
                              attrs: {
                                label: _vm.$t("outboundFee"),
                                prefix: "$"
                              },
                              model: {
                                value: _vm.editingUPCItem.outboundFee,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.editingUPCItem,
                                    "outboundFee",
                                    _vm._n($$v)
                                  )
                                },
                                expression: "editingUPCItem.outboundFee"
                              }
                            })
                          : _vm._e()
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "v-flex",
                      { attrs: { sm3: "" } },
                      [
                        _vm.editingUPCItem.size === "custom"
                          ? _c("v-text-field", {
                              attrs: {
                                label: _vm.$t("storageFee"),
                                prefix: "$"
                              },
                              model: {
                                value: _vm.editingUPCItem.storageFee,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.editingUPCItem,
                                    "storageFee",
                                    _vm._n($$v)
                                  )
                                },
                                expression: "editingUPCItem.storageFee"
                              }
                            })
                          : _vm._e()
                      ],
                      1
                    )
                  ],
                  1
                )
              ]
            },
            proxy: true
          }
        ]),
        model: {
          value: _vm.showEditUPCDesc,
          callback: function($$v) {
            _vm.showEditUPCDesc = $$v
          },
          expression: "showEditUPCDesc"
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-06cbee92", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-06cbee92","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/UpcMainTabItem.vue
// module id = null
// module chunks = 